import { render } from "./HiStageLink.vue?vue&type=template&id=ae5ed3e0"
import script from "./HiStageLink.vue?vue&type=script&lang=js"
export * from "./HiStageLink.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__